import ClipLoader from "react-spinners/ClipLoader";
import React from "react";
import styled from 'styled-components';

const LoaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const LoaderText = styled.p`
    font-family: Roboto Condensed, serif;
    color: ${({color}) => color ?? 'black'};
    font-size: 13px;
    text-align: center;
`;

const LoadingSpinner = ({color}) => {
    return (
        <LoaderWrapper>
            <ClipLoader color={'green'} loading={true} size={70}/>
            <LoaderText color={color}>{'Proszę czekać. Trwa wczytywanie danych...'}</LoaderText>
        </LoaderWrapper>
    );
};

export default LoadingSpinner;
